import { modes } from "../modes";
import { roles } from "../roles";

export const mechanicalTaskPermissionProfiles = {
    TASK_LIST: {
        [modes.EDIT]: [roles.MECHANIC]
    },
}